module.exports = __webpack_public_path__ + "static/desktop/img/softcover-en.34260329.png";